import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getParticipantesByCapacitacion } from "../../Services/participantes_service";

const initialState = {
  participantes: [],
  participante: {
    id: 0,
    dpi: "",
    nombres: "",
    apellidos: "",
    fechaCreacion: "",
    estado: true,
  },
};

export const participantesSlice = createSlice({
  name: "participantes",
  initialState,
  reducers: {
    setParticipantes: (state, action) => {
      state.participantes = action.payload || [];
    },
    setParticipante: (state, action) => {
      state.participante = !action.payload ? initialState.participante : action.payload;
    },
  },
});

export const fetchParticipantesByCapacitacion = createAsyncThunk(
  "participantes/fetchParticipantesByCapacitacion",
  async (idCapacitacion, { dispatch }) => {
    const participantesRes = await getParticipantesByCapacitacion(idCapacitacion);
    dispatch(setParticipantes(participantesRes));
  }
);

export const { setParticipantes, setParticipante } = participantesSlice.actions;
export default participantesSlice.reducer;